import { useUser } from 'app/state/contexts/UserContext';
import { CommentItem } from './types';

export const useCommentActions = (comment: CommentItem) => {
  const { user } = useUser();
  const isOwner = comment?.user?.id === user?.id;
  const canEdit = !comment.closedAt;
  const canToggleStatus = !comment.isOrphaned;
  const canDelete = isOwner;

  return { canEdit, canToggleStatus, canDelete, hasAny: canEdit || canToggleStatus || canDelete };
};
